var _objectSpread = require("/Users/lemontreeran/SourceTree/blockchain-projects/Waxara/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e6) { throw _e6; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e7) { didErr = true; err = _e7; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function t(t) {
  return t && "object" == typeof t && "default" in t ? t.default : t;
}

var i = t(require("ethjs-provider-http")),
    e = t(require("ethjs-query")),
    n = t(require("ethjs-abi")),
    r = require("buffer"),
    o = t(r),
    s = t(require("ethjs-contract")),
    h = require("elliptic"),
    u = require("js-sha3"),
    a = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    l = function (t, i, e) {
  return function (t) {
    !function (t, i) {
      function e(t, i) {
        if (!t) throw new Error(i || "Assertion failed");
      }

      function n(t, i) {
        t.super_ = i;

        var e = function e() {};

        e.prototype = i.prototype, t.prototype = new e(), t.prototype.constructor = t;
      }

      function r(t, i, e) {
        if (r.isBN(t)) return t;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== i && "be" !== i || (e = i, i = 10), this._init(t || 0, i || 10, e || "be"));
      }

      var s;
      "object" == typeof t ? t.exports = r : i.BN = r, r.BN = r, r.wordSize = 26;

      try {
        s = o.Buffer;
      } catch (t) {}

      function h(t, i, e) {
        for (var n = 0, r = Math.min(t.length, e), o = i; o < r; o++) {
          var s = t.charCodeAt(o) - 48;
          n <<= 4, n |= s >= 49 && s <= 54 ? s - 49 + 10 : s >= 17 && s <= 22 ? s - 17 + 10 : 15 & s;
        }

        return n;
      }

      function u(t, i, e, n) {
        for (var r = 0, o = Math.min(t.length, e), s = i; s < o; s++) {
          var h = t.charCodeAt(s) - 48;
          r *= n, r += h >= 49 ? h - 49 + 10 : h >= 17 ? h - 17 + 10 : h;
        }

        return r;
      }

      r.isBN = function (t) {
        return t instanceof r || null !== t && "object" == typeof t && t.constructor.wordSize === r.wordSize && Array.isArray(t.words);
      }, r.max = function (t, i) {
        return t.cmp(i) > 0 ? t : i;
      }, r.min = function (t, i) {
        return t.cmp(i) < 0 ? t : i;
      }, r.prototype._init = function (t, i, n) {
        if ("number" == typeof t) return this._initNumber(t, i, n);
        if ("object" == typeof t) return this._initArray(t, i, n);
        "hex" === i && (i = 16), e(i === (0 | i) && i >= 2 && i <= 36);
        var r = 0;
        "-" === (t = t.toString().replace(/\s+/g, ""))[0] && r++, 16 === i ? this._parseHex(t, r) : this._parseBase(t, i, r), "-" === t[0] && (this.negative = 1), this.strip(), "le" === n && this._initArray(this.toArray(), i, n);
      }, r.prototype._initNumber = function (t, i, n) {
        t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (e(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === n && this._initArray(this.toArray(), i, n);
      }, r.prototype._initArray = function (t, i, n) {
        if (e("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

        for (var r = 0; r < this.length; r++) {
          this.words[r] = 0;
        }

        var o,
            s,
            h = 0;
        if ("be" === n) for (r = t.length - 1, o = 0; r >= 0; r -= 3) {
          this.words[o] |= (s = t[r] | t[r - 1] << 8 | t[r - 2] << 16) << h & 67108863, this.words[o + 1] = s >>> 26 - h & 67108863, (h += 24) >= 26 && (h -= 26, o++);
        } else if ("le" === n) for (r = 0, o = 0; r < t.length; r += 3) {
          this.words[o] |= (s = t[r] | t[r + 1] << 8 | t[r + 2] << 16) << h & 67108863, this.words[o + 1] = s >>> 26 - h & 67108863, (h += 24) >= 26 && (h -= 26, o++);
        }
        return this.strip();
      }, r.prototype._parseHex = function (t, i) {
        this.length = Math.ceil((t.length - i) / 6), this.words = new Array(this.length);

        for (var e = 0; e < this.length; e++) {
          this.words[e] = 0;
        }

        var n,
            r,
            o = 0;

        for (e = t.length - 6, n = 0; e >= i; e -= 6) {
          r = h(t, e, e + 6), this.words[n] |= r << o & 67108863, this.words[n + 1] |= r >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, n++);
        }

        e + 6 !== i && (r = h(t, i, e + 6), this.words[n] |= r << o & 67108863, this.words[n + 1] |= r >>> 26 - o & 4194303), this.strip();
      }, r.prototype._parseBase = function (t, i, e) {
        this.words = [0], this.length = 1;

        for (var n = 0, r = 1; r <= 67108863; r *= i) {
          n++;
        }

        n--, r = r / i | 0;

        for (var o = t.length - e, s = o % n, h = Math.min(o, o - s) + e, a = 0, l = e; l < h; l += n) {
          a = u(t, l, l + n, i), this.imuln(r), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }

        if (0 !== s) {
          var m = 1;

          for (a = u(t, l, t.length, i), l = 0; l < s; l++) {
            m *= i;
          }

          this.imuln(m), this.words[0] + a < 67108864 ? this.words[0] += a : this._iaddn(a);
        }
      }, r.prototype.copy = function (t) {
        t.words = new Array(this.length);

        for (var i = 0; i < this.length; i++) {
          t.words[i] = this.words[i];
        }

        t.length = this.length, t.negative = this.negative, t.red = this.red;
      }, r.prototype.clone = function () {
        var t = new r(null);
        return this.copy(t), t;
      }, r.prototype._expand = function (t) {
        for (; this.length < t;) {
          this.words[this.length++] = 0;
        }

        return this;
      }, r.prototype.strip = function () {
        for (; this.length > 1 && 0 === this.words[this.length - 1];) {
          this.length--;
        }

        return this._normSign();
      }, r.prototype._normSign = function () {
        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
      }, r.prototype.inspect = function () {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var a = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
          l = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
          m = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

      function d(t, i, e) {
        e.negative = i.negative ^ t.negative;
        var n = t.length + i.length | 0;
        e.length = n, n = n - 1 | 0;
        var r = 0 | t.words[0],
            o = 0 | i.words[0],
            s = r * o,
            h = s / 67108864 | 0;
        e.words[0] = 67108863 & s;

        for (var u = 1; u < n; u++) {
          for (var a = h >>> 26, l = 67108863 & h, m = Math.min(u, i.length - 1), d = Math.max(0, u - t.length + 1); d <= m; d++) {
            a += (s = (r = 0 | t.words[u - d | 0]) * (o = 0 | i.words[d]) + l) / 67108864 | 0, l = 67108863 & s;
          }

          e.words[u] = 0 | l, h = 0 | a;
        }

        return 0 !== h ? e.words[u] = 0 | h : e.length--, e.strip();
      }

      r.prototype.toString = function (t, i) {
        var n;

        if (i = 0 | i || 1, 16 === (t = t || 10) || "hex" === t) {
          n = "";

          for (var r = 0, o = 0, s = 0; s < this.length; s++) {
            var h = this.words[s],
                u = (16777215 & (h << r | o)).toString(16);
            n = 0 != (o = h >>> 24 - r & 16777215) || s !== this.length - 1 ? a[6 - u.length] + u + n : u + n, (r += 2) >= 26 && (r -= 26, s--);
          }

          for (0 !== o && (n = o.toString(16) + n); n.length % i != 0;) {
            n = "0" + n;
          }

          return 0 !== this.negative && (n = "-" + n), n;
        }

        if (t === (0 | t) && t >= 2 && t <= 36) {
          var d = l[t],
              f = m[t];
          n = "";
          var p = this.clone();

          for (p.negative = 0; !p.isZero();) {
            var c = p.modn(f).toString(t);
            n = (p = p.idivn(f)).isZero() ? c + n : a[d - c.length] + c + n;
          }

          for (this.isZero() && (n = "0" + n); n.length % i != 0;) {
            n = "0" + n;
          }

          return 0 !== this.negative && (n = "-" + n), n;
        }

        e(!1, "Base should be between 2 and 36");
      }, r.prototype.toNumber = function () {
        var t = this.words[0];
        return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && e(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
      }, r.prototype.toJSON = function () {
        return this.toString(16);
      }, r.prototype.toBuffer = function (t, i) {
        return e(void 0 !== s), this.toArrayLike(s, t, i);
      }, r.prototype.toArray = function (t, i) {
        return this.toArrayLike(Array, t, i);
      }, r.prototype.toArrayLike = function (t, i, n) {
        var r = this.byteLength(),
            o = n || Math.max(1, r);
        e(r <= o, "byte array longer than desired length"), e(o > 0, "Requested array length <= 0"), this.strip();
        var s,
            h,
            u = "le" === i,
            a = new t(o),
            l = this.clone();

        if (u) {
          for (h = 0; !l.isZero(); h++) {
            s = l.andln(255), l.iushrn(8), a[h] = s;
          }

          for (; h < o; h++) {
            a[h] = 0;
          }
        } else {
          for (h = 0; h < o - r; h++) {
            a[h] = 0;
          }

          for (h = 0; !l.isZero(); h++) {
            s = l.andln(255), l.iushrn(8), a[o - h - 1] = s;
          }
        }

        return a;
      }, r.prototype._countBits = Math.clz32 ? function (t) {
        return 32 - Math.clz32(t);
      } : function (t) {
        var i = t,
            e = 0;
        return i >= 4096 && (e += 13, i >>>= 13), i >= 64 && (e += 7, i >>>= 7), i >= 8 && (e += 4, i >>>= 4), i >= 2 && (e += 2, i >>>= 2), e + i;
      }, r.prototype._zeroBits = function (t) {
        if (0 === t) return 26;
        var i = t,
            e = 0;
        return 0 == (8191 & i) && (e += 13, i >>>= 13), 0 == (127 & i) && (e += 7, i >>>= 7), 0 == (15 & i) && (e += 4, i >>>= 4), 0 == (3 & i) && (e += 2, i >>>= 2), 0 == (1 & i) && e++, e;
      }, r.prototype.bitLength = function () {
        var t = this._countBits(this.words[this.length - 1]);

        return 26 * (this.length - 1) + t;
      }, r.prototype.zeroBits = function () {
        if (this.isZero()) return 0;

        for (var t = 0, i = 0; i < this.length; i++) {
          var e = this._zeroBits(this.words[i]);

          if (t += e, 26 !== e) break;
        }

        return t;
      }, r.prototype.byteLength = function () {
        return Math.ceil(this.bitLength() / 8);
      }, r.prototype.toTwos = function (t) {
        return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
      }, r.prototype.fromTwos = function (t) {
        return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
      }, r.prototype.isNeg = function () {
        return 0 !== this.negative;
      }, r.prototype.neg = function () {
        return this.clone().ineg();
      }, r.prototype.ineg = function () {
        return this.isZero() || (this.negative ^= 1), this;
      }, r.prototype.iuor = function (t) {
        for (; this.length < t.length;) {
          this.words[this.length++] = 0;
        }

        for (var i = 0; i < t.length; i++) {
          this.words[i] = this.words[i] | t.words[i];
        }

        return this.strip();
      }, r.prototype.ior = function (t) {
        return e(0 == (this.negative | t.negative)), this.iuor(t);
      }, r.prototype.or = function (t) {
        return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
      }, r.prototype.uor = function (t) {
        return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
      }, r.prototype.iuand = function (t) {
        var i;
        i = this.length > t.length ? t : this;

        for (var e = 0; e < i.length; e++) {
          this.words[e] = this.words[e] & t.words[e];
        }

        return this.length = i.length, this.strip();
      }, r.prototype.iand = function (t) {
        return e(0 == (this.negative | t.negative)), this.iuand(t);
      }, r.prototype.and = function (t) {
        return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
      }, r.prototype.uand = function (t) {
        return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
      }, r.prototype.iuxor = function (t) {
        var i, e;
        this.length > t.length ? (i = this, e = t) : (i = t, e = this);

        for (var n = 0; n < e.length; n++) {
          this.words[n] = i.words[n] ^ e.words[n];
        }

        if (this !== i) for (; n < i.length; n++) {
          this.words[n] = i.words[n];
        }
        return this.length = i.length, this.strip();
      }, r.prototype.ixor = function (t) {
        return e(0 == (this.negative | t.negative)), this.iuxor(t);
      }, r.prototype.xor = function (t) {
        return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
      }, r.prototype.uxor = function (t) {
        return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
      }, r.prototype.inotn = function (t) {
        e("number" == typeof t && t >= 0);
        var i = 0 | Math.ceil(t / 26),
            n = t % 26;
        this._expand(i), n > 0 && i--;

        for (var r = 0; r < i; r++) {
          this.words[r] = 67108863 & ~this.words[r];
        }

        return n > 0 && (this.words[r] = ~this.words[r] & 67108863 >> 26 - n), this.strip();
      }, r.prototype.notn = function (t) {
        return this.clone().inotn(t);
      }, r.prototype.setn = function (t, i) {
        e("number" == typeof t && t >= 0);
        var n = t / 26 | 0,
            r = t % 26;
        return this._expand(n + 1), this.words[n] = i ? this.words[n] | 1 << r : this.words[n] & ~(1 << r), this.strip();
      }, r.prototype.iadd = function (t) {
        var i, e, n;
        if (0 !== this.negative && 0 === t.negative) return this.negative = 0, i = this.isub(t), this.negative ^= 1, this._normSign();
        if (0 === this.negative && 0 !== t.negative) return t.negative = 0, i = this.isub(t), t.negative = 1, i._normSign();
        this.length > t.length ? (e = this, n = t) : (e = t, n = this);

        for (var r = 0, o = 0; o < n.length; o++) {
          this.words[o] = 67108863 & (i = (0 | e.words[o]) + (0 | n.words[o]) + r), r = i >>> 26;
        }

        for (; 0 !== r && o < e.length; o++) {
          this.words[o] = 67108863 & (i = (0 | e.words[o]) + r), r = i >>> 26;
        }

        if (this.length = e.length, 0 !== r) this.words[this.length] = r, this.length++;else if (e !== this) for (; o < e.length; o++) {
          this.words[o] = e.words[o];
        }
        return this;
      }, r.prototype.add = function (t) {
        var i;
        return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, i = this.sub(t), t.negative ^= 1, i) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, i = t.sub(this), this.negative = 1, i) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
      }, r.prototype.isub = function (t) {
        if (0 !== t.negative) {
          t.negative = 0;
          var i = this.iadd(t);
          return t.negative = 1, i._normSign();
        }

        if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
        var e,
            n,
            r = this.cmp(t);
        if (0 === r) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        r > 0 ? (e = this, n = t) : (e = t, n = this);

        for (var o = 0, s = 0; s < n.length; s++) {
          o = (i = (0 | e.words[s]) - (0 | n.words[s]) + o) >> 26, this.words[s] = 67108863 & i;
        }

        for (; 0 !== o && s < e.length; s++) {
          o = (i = (0 | e.words[s]) + o) >> 26, this.words[s] = 67108863 & i;
        }

        if (0 === o && s < e.length && e !== this) for (; s < e.length; s++) {
          this.words[s] = e.words[s];
        }
        return this.length = Math.max(this.length, s), e !== this && (this.negative = 1), this.strip();
      }, r.prototype.sub = function (t) {
        return this.clone().isub(t);
      };

      var f = function f(t, i, e) {
        var n,
            r,
            o,
            s = t.words,
            h = i.words,
            u = e.words,
            a = 0,
            l = 0 | s[0],
            m = 8191 & l,
            d = l >>> 13,
            f = 0 | s[1],
            p = 8191 & f,
            c = f >>> 13,
            y = 0 | s[2],
            v = 8191 & y,
            g = y >>> 13,
            M = 0 | s[3],
            w = 8191 & M,
            b = M >>> 13,
            _ = 0 | s[4],
            k = 8191 & _,
            x = _ >>> 13,
            S = 0 | s[5],
            A = 8191 & S,
            R = S >>> 13,
            B = 0 | s[6],
            q = 8191 & B,
            D = B >>> 13,
            K = 0 | s[7],
            T = 8191 & K,
            Z = K >>> 13,
            N = 0 | s[8],
            I = 8191 & N,
            j = N >>> 13,
            E = 0 | s[9],
            O = 8191 & E,
            C = E >>> 13,
            L = 0 | h[0],
            P = 8191 & L,
            $ = L >>> 13,
            z = 0 | h[1],
            V = 8191 & z,
            F = z >>> 13,
            U = 0 | h[2],
            H = 8191 & U,
            G = U >>> 13,
            J = 0 | h[3],
            W = 8191 & J,
            Y = J >>> 13,
            Q = 0 | h[4],
            X = 8191 & Q,
            tt = Q >>> 13,
            it = 0 | h[5],
            et = 8191 & it,
            nt = it >>> 13,
            rt = 0 | h[6],
            ot = 8191 & rt,
            st = rt >>> 13,
            ht = 0 | h[7],
            ut = 8191 & ht,
            at = ht >>> 13,
            lt = 0 | h[8],
            mt = 8191 & lt,
            dt = lt >>> 13,
            ft = 0 | h[9],
            pt = 8191 & ft,
            ct = ft >>> 13;

        e.negative = t.negative ^ i.negative, e.length = 19;
        var yt = (a + (n = Math.imul(m, P)) | 0) + ((8191 & (r = (r = Math.imul(m, $)) + Math.imul(d, P) | 0)) << 13) | 0;
        a = ((o = Math.imul(d, $)) + (r >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, n = Math.imul(p, P), r = (r = Math.imul(p, $)) + Math.imul(c, P) | 0, o = Math.imul(c, $);
        var vt = (a + (n = n + Math.imul(m, V) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, F) | 0) + Math.imul(d, V) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(d, F) | 0) + (r >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, n = Math.imul(v, P), r = (r = Math.imul(v, $)) + Math.imul(g, P) | 0, o = Math.imul(g, $), n = n + Math.imul(p, V) | 0, r = (r = r + Math.imul(p, F) | 0) + Math.imul(c, V) | 0, o = o + Math.imul(c, F) | 0;
        var gt = (a + (n = n + Math.imul(m, H) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, G) | 0) + Math.imul(d, H) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(d, G) | 0) + (r >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, n = Math.imul(w, P), r = (r = Math.imul(w, $)) + Math.imul(b, P) | 0, o = Math.imul(b, $), n = n + Math.imul(v, V) | 0, r = (r = r + Math.imul(v, F) | 0) + Math.imul(g, V) | 0, o = o + Math.imul(g, F) | 0, n = n + Math.imul(p, H) | 0, r = (r = r + Math.imul(p, G) | 0) + Math.imul(c, H) | 0, o = o + Math.imul(c, G) | 0;
        var Mt = (a + (n = n + Math.imul(m, W) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, Y) | 0) + Math.imul(d, W) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(d, Y) | 0) + (r >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, n = Math.imul(k, P), r = (r = Math.imul(k, $)) + Math.imul(x, P) | 0, o = Math.imul(x, $), n = n + Math.imul(w, V) | 0, r = (r = r + Math.imul(w, F) | 0) + Math.imul(b, V) | 0, o = o + Math.imul(b, F) | 0, n = n + Math.imul(v, H) | 0, r = (r = r + Math.imul(v, G) | 0) + Math.imul(g, H) | 0, o = o + Math.imul(g, G) | 0, n = n + Math.imul(p, W) | 0, r = (r = r + Math.imul(p, Y) | 0) + Math.imul(c, W) | 0, o = o + Math.imul(c, Y) | 0;
        var wt = (a + (n = n + Math.imul(m, X) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, tt) | 0) + Math.imul(d, X) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(d, tt) | 0) + (r >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, n = Math.imul(A, P), r = (r = Math.imul(A, $)) + Math.imul(R, P) | 0, o = Math.imul(R, $), n = n + Math.imul(k, V) | 0, r = (r = r + Math.imul(k, F) | 0) + Math.imul(x, V) | 0, o = o + Math.imul(x, F) | 0, n = n + Math.imul(w, H) | 0, r = (r = r + Math.imul(w, G) | 0) + Math.imul(b, H) | 0, o = o + Math.imul(b, G) | 0, n = n + Math.imul(v, W) | 0, r = (r = r + Math.imul(v, Y) | 0) + Math.imul(g, W) | 0, o = o + Math.imul(g, Y) | 0, n = n + Math.imul(p, X) | 0, r = (r = r + Math.imul(p, tt) | 0) + Math.imul(c, X) | 0, o = o + Math.imul(c, tt) | 0;
        var bt = (a + (n = n + Math.imul(m, et) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, nt) | 0) + Math.imul(d, et) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(d, nt) | 0) + (r >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, n = Math.imul(q, P), r = (r = Math.imul(q, $)) + Math.imul(D, P) | 0, o = Math.imul(D, $), n = n + Math.imul(A, V) | 0, r = (r = r + Math.imul(A, F) | 0) + Math.imul(R, V) | 0, o = o + Math.imul(R, F) | 0, n = n + Math.imul(k, H) | 0, r = (r = r + Math.imul(k, G) | 0) + Math.imul(x, H) | 0, o = o + Math.imul(x, G) | 0, n = n + Math.imul(w, W) | 0, r = (r = r + Math.imul(w, Y) | 0) + Math.imul(b, W) | 0, o = o + Math.imul(b, Y) | 0, n = n + Math.imul(v, X) | 0, r = (r = r + Math.imul(v, tt) | 0) + Math.imul(g, X) | 0, o = o + Math.imul(g, tt) | 0, n = n + Math.imul(p, et) | 0, r = (r = r + Math.imul(p, nt) | 0) + Math.imul(c, et) | 0, o = o + Math.imul(c, nt) | 0;

        var _t = (a + (n = n + Math.imul(m, ot) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, st) | 0) + Math.imul(d, ot) | 0)) << 13) | 0;

        a = ((o = o + Math.imul(d, st) | 0) + (r >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, n = Math.imul(T, P), r = (r = Math.imul(T, $)) + Math.imul(Z, P) | 0, o = Math.imul(Z, $), n = n + Math.imul(q, V) | 0, r = (r = r + Math.imul(q, F) | 0) + Math.imul(D, V) | 0, o = o + Math.imul(D, F) | 0, n = n + Math.imul(A, H) | 0, r = (r = r + Math.imul(A, G) | 0) + Math.imul(R, H) | 0, o = o + Math.imul(R, G) | 0, n = n + Math.imul(k, W) | 0, r = (r = r + Math.imul(k, Y) | 0) + Math.imul(x, W) | 0, o = o + Math.imul(x, Y) | 0, n = n + Math.imul(w, X) | 0, r = (r = r + Math.imul(w, tt) | 0) + Math.imul(b, X) | 0, o = o + Math.imul(b, tt) | 0, n = n + Math.imul(v, et) | 0, r = (r = r + Math.imul(v, nt) | 0) + Math.imul(g, et) | 0, o = o + Math.imul(g, nt) | 0, n = n + Math.imul(p, ot) | 0, r = (r = r + Math.imul(p, st) | 0) + Math.imul(c, ot) | 0, o = o + Math.imul(c, st) | 0;
        var kt = (a + (n = n + Math.imul(m, ut) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, at) | 0) + Math.imul(d, ut) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(d, at) | 0) + (r >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, n = Math.imul(I, P), r = (r = Math.imul(I, $)) + Math.imul(j, P) | 0, o = Math.imul(j, $), n = n + Math.imul(T, V) | 0, r = (r = r + Math.imul(T, F) | 0) + Math.imul(Z, V) | 0, o = o + Math.imul(Z, F) | 0, n = n + Math.imul(q, H) | 0, r = (r = r + Math.imul(q, G) | 0) + Math.imul(D, H) | 0, o = o + Math.imul(D, G) | 0, n = n + Math.imul(A, W) | 0, r = (r = r + Math.imul(A, Y) | 0) + Math.imul(R, W) | 0, o = o + Math.imul(R, Y) | 0, n = n + Math.imul(k, X) | 0, r = (r = r + Math.imul(k, tt) | 0) + Math.imul(x, X) | 0, o = o + Math.imul(x, tt) | 0, n = n + Math.imul(w, et) | 0, r = (r = r + Math.imul(w, nt) | 0) + Math.imul(b, et) | 0, o = o + Math.imul(b, nt) | 0, n = n + Math.imul(v, ot) | 0, r = (r = r + Math.imul(v, st) | 0) + Math.imul(g, ot) | 0, o = o + Math.imul(g, st) | 0, n = n + Math.imul(p, ut) | 0, r = (r = r + Math.imul(p, at) | 0) + Math.imul(c, ut) | 0, o = o + Math.imul(c, at) | 0;
        var xt = (a + (n = n + Math.imul(m, mt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, dt) | 0) + Math.imul(d, mt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(d, dt) | 0) + (r >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, n = Math.imul(O, P), r = (r = Math.imul(O, $)) + Math.imul(C, P) | 0, o = Math.imul(C, $), n = n + Math.imul(I, V) | 0, r = (r = r + Math.imul(I, F) | 0) + Math.imul(j, V) | 0, o = o + Math.imul(j, F) | 0, n = n + Math.imul(T, H) | 0, r = (r = r + Math.imul(T, G) | 0) + Math.imul(Z, H) | 0, o = o + Math.imul(Z, G) | 0, n = n + Math.imul(q, W) | 0, r = (r = r + Math.imul(q, Y) | 0) + Math.imul(D, W) | 0, o = o + Math.imul(D, Y) | 0, n = n + Math.imul(A, X) | 0, r = (r = r + Math.imul(A, tt) | 0) + Math.imul(R, X) | 0, o = o + Math.imul(R, tt) | 0, n = n + Math.imul(k, et) | 0, r = (r = r + Math.imul(k, nt) | 0) + Math.imul(x, et) | 0, o = o + Math.imul(x, nt) | 0, n = n + Math.imul(w, ot) | 0, r = (r = r + Math.imul(w, st) | 0) + Math.imul(b, ot) | 0, o = o + Math.imul(b, st) | 0, n = n + Math.imul(v, ut) | 0, r = (r = r + Math.imul(v, at) | 0) + Math.imul(g, ut) | 0, o = o + Math.imul(g, at) | 0, n = n + Math.imul(p, mt) | 0, r = (r = r + Math.imul(p, dt) | 0) + Math.imul(c, mt) | 0, o = o + Math.imul(c, dt) | 0;
        var St = (a + (n = n + Math.imul(m, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(m, ct) | 0) + Math.imul(d, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(d, ct) | 0) + (r >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, n = Math.imul(O, V), r = (r = Math.imul(O, F)) + Math.imul(C, V) | 0, o = Math.imul(C, F), n = n + Math.imul(I, H) | 0, r = (r = r + Math.imul(I, G) | 0) + Math.imul(j, H) | 0, o = o + Math.imul(j, G) | 0, n = n + Math.imul(T, W) | 0, r = (r = r + Math.imul(T, Y) | 0) + Math.imul(Z, W) | 0, o = o + Math.imul(Z, Y) | 0, n = n + Math.imul(q, X) | 0, r = (r = r + Math.imul(q, tt) | 0) + Math.imul(D, X) | 0, o = o + Math.imul(D, tt) | 0, n = n + Math.imul(A, et) | 0, r = (r = r + Math.imul(A, nt) | 0) + Math.imul(R, et) | 0, o = o + Math.imul(R, nt) | 0, n = n + Math.imul(k, ot) | 0, r = (r = r + Math.imul(k, st) | 0) + Math.imul(x, ot) | 0, o = o + Math.imul(x, st) | 0, n = n + Math.imul(w, ut) | 0, r = (r = r + Math.imul(w, at) | 0) + Math.imul(b, ut) | 0, o = o + Math.imul(b, at) | 0, n = n + Math.imul(v, mt) | 0, r = (r = r + Math.imul(v, dt) | 0) + Math.imul(g, mt) | 0, o = o + Math.imul(g, dt) | 0;
        var At = (a + (n = n + Math.imul(p, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(p, ct) | 0) + Math.imul(c, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(c, ct) | 0) + (r >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, n = Math.imul(O, H), r = (r = Math.imul(O, G)) + Math.imul(C, H) | 0, o = Math.imul(C, G), n = n + Math.imul(I, W) | 0, r = (r = r + Math.imul(I, Y) | 0) + Math.imul(j, W) | 0, o = o + Math.imul(j, Y) | 0, n = n + Math.imul(T, X) | 0, r = (r = r + Math.imul(T, tt) | 0) + Math.imul(Z, X) | 0, o = o + Math.imul(Z, tt) | 0, n = n + Math.imul(q, et) | 0, r = (r = r + Math.imul(q, nt) | 0) + Math.imul(D, et) | 0, o = o + Math.imul(D, nt) | 0, n = n + Math.imul(A, ot) | 0, r = (r = r + Math.imul(A, st) | 0) + Math.imul(R, ot) | 0, o = o + Math.imul(R, st) | 0, n = n + Math.imul(k, ut) | 0, r = (r = r + Math.imul(k, at) | 0) + Math.imul(x, ut) | 0, o = o + Math.imul(x, at) | 0, n = n + Math.imul(w, mt) | 0, r = (r = r + Math.imul(w, dt) | 0) + Math.imul(b, mt) | 0, o = o + Math.imul(b, dt) | 0;
        var Rt = (a + (n = n + Math.imul(v, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(v, ct) | 0) + Math.imul(g, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(g, ct) | 0) + (r >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, n = Math.imul(O, W), r = (r = Math.imul(O, Y)) + Math.imul(C, W) | 0, o = Math.imul(C, Y), n = n + Math.imul(I, X) | 0, r = (r = r + Math.imul(I, tt) | 0) + Math.imul(j, X) | 0, o = o + Math.imul(j, tt) | 0, n = n + Math.imul(T, et) | 0, r = (r = r + Math.imul(T, nt) | 0) + Math.imul(Z, et) | 0, o = o + Math.imul(Z, nt) | 0, n = n + Math.imul(q, ot) | 0, r = (r = r + Math.imul(q, st) | 0) + Math.imul(D, ot) | 0, o = o + Math.imul(D, st) | 0, n = n + Math.imul(A, ut) | 0, r = (r = r + Math.imul(A, at) | 0) + Math.imul(R, ut) | 0, o = o + Math.imul(R, at) | 0, n = n + Math.imul(k, mt) | 0, r = (r = r + Math.imul(k, dt) | 0) + Math.imul(x, mt) | 0, o = o + Math.imul(x, dt) | 0;
        var Bt = (a + (n = n + Math.imul(w, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(w, ct) | 0) + Math.imul(b, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(b, ct) | 0) + (r >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, n = Math.imul(O, X), r = (r = Math.imul(O, tt)) + Math.imul(C, X) | 0, o = Math.imul(C, tt), n = n + Math.imul(I, et) | 0, r = (r = r + Math.imul(I, nt) | 0) + Math.imul(j, et) | 0, o = o + Math.imul(j, nt) | 0, n = n + Math.imul(T, ot) | 0, r = (r = r + Math.imul(T, st) | 0) + Math.imul(Z, ot) | 0, o = o + Math.imul(Z, st) | 0, n = n + Math.imul(q, ut) | 0, r = (r = r + Math.imul(q, at) | 0) + Math.imul(D, ut) | 0, o = o + Math.imul(D, at) | 0, n = n + Math.imul(A, mt) | 0, r = (r = r + Math.imul(A, dt) | 0) + Math.imul(R, mt) | 0, o = o + Math.imul(R, dt) | 0;
        var qt = (a + (n = n + Math.imul(k, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(k, ct) | 0) + Math.imul(x, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(x, ct) | 0) + (r >>> 13) | 0) + (qt >>> 26) | 0, qt &= 67108863, n = Math.imul(O, et), r = (r = Math.imul(O, nt)) + Math.imul(C, et) | 0, o = Math.imul(C, nt), n = n + Math.imul(I, ot) | 0, r = (r = r + Math.imul(I, st) | 0) + Math.imul(j, ot) | 0, o = o + Math.imul(j, st) | 0, n = n + Math.imul(T, ut) | 0, r = (r = r + Math.imul(T, at) | 0) + Math.imul(Z, ut) | 0, o = o + Math.imul(Z, at) | 0, n = n + Math.imul(q, mt) | 0, r = (r = r + Math.imul(q, dt) | 0) + Math.imul(D, mt) | 0, o = o + Math.imul(D, dt) | 0;
        var Dt = (a + (n = n + Math.imul(A, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(A, ct) | 0) + Math.imul(R, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(R, ct) | 0) + (r >>> 13) | 0) + (Dt >>> 26) | 0, Dt &= 67108863, n = Math.imul(O, ot), r = (r = Math.imul(O, st)) + Math.imul(C, ot) | 0, o = Math.imul(C, st), n = n + Math.imul(I, ut) | 0, r = (r = r + Math.imul(I, at) | 0) + Math.imul(j, ut) | 0, o = o + Math.imul(j, at) | 0, n = n + Math.imul(T, mt) | 0, r = (r = r + Math.imul(T, dt) | 0) + Math.imul(Z, mt) | 0, o = o + Math.imul(Z, dt) | 0;
        var Kt = (a + (n = n + Math.imul(q, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(q, ct) | 0) + Math.imul(D, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(D, ct) | 0) + (r >>> 13) | 0) + (Kt >>> 26) | 0, Kt &= 67108863, n = Math.imul(O, ut), r = (r = Math.imul(O, at)) + Math.imul(C, ut) | 0, o = Math.imul(C, at), n = n + Math.imul(I, mt) | 0, r = (r = r + Math.imul(I, dt) | 0) + Math.imul(j, mt) | 0, o = o + Math.imul(j, dt) | 0;
        var Tt = (a + (n = n + Math.imul(T, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(T, ct) | 0) + Math.imul(Z, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(Z, ct) | 0) + (r >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, n = Math.imul(O, mt), r = (r = Math.imul(O, dt)) + Math.imul(C, mt) | 0, o = Math.imul(C, dt);
        var Zt = (a + (n = n + Math.imul(I, pt) | 0) | 0) + ((8191 & (r = (r = r + Math.imul(I, ct) | 0) + Math.imul(j, pt) | 0)) << 13) | 0;
        a = ((o = o + Math.imul(j, ct) | 0) + (r >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863;
        var Nt = (a + (n = Math.imul(O, pt)) | 0) + ((8191 & (r = (r = Math.imul(O, ct)) + Math.imul(C, pt) | 0)) << 13) | 0;
        return a = ((o = Math.imul(C, ct)) + (r >>> 13) | 0) + (Nt >>> 26) | 0, Nt &= 67108863, u[0] = yt, u[1] = vt, u[2] = gt, u[3] = Mt, u[4] = wt, u[5] = bt, u[6] = _t, u[7] = kt, u[8] = xt, u[9] = St, u[10] = At, u[11] = Rt, u[12] = Bt, u[13] = qt, u[14] = Dt, u[15] = Kt, u[16] = Tt, u[17] = Zt, u[18] = Nt, 0 !== a && (u[19] = a, e.length++), e;
      };

      function p(t, i, e) {
        return new c().mulp(t, i, e);
      }

      function c(t, i) {
        this.x = t, this.y = i;
      }

      Math.imul || (f = d), r.prototype.mulTo = function (t, i) {
        var e = this.length + t.length;
        return 10 === this.length && 10 === t.length ? f(this, t, i) : e < 63 ? d(this, t, i) : e < 1024 ? function (t, i, e) {
          e.negative = i.negative ^ t.negative, e.length = t.length + i.length;

          for (var n = 0, r = 0, o = 0; o < e.length - 1; o++) {
            var s = r;
            r = 0;

            for (var h = 67108863 & n, u = Math.min(o, i.length - 1), a = Math.max(0, o - t.length + 1); a <= u; a++) {
              var l = (0 | t.words[o - a]) * (0 | i.words[a]),
                  m = 67108863 & l;
              h = 67108863 & (m = m + h | 0), r += (s = (s = s + (l / 67108864 | 0) | 0) + (m >>> 26) | 0) >>> 26, s &= 67108863;
            }

            e.words[o] = h, n = s, s = r;
          }

          return 0 !== n ? e.words[o] = n : e.length--, e.strip();
        }(this, t, i) : p(this, t, i);
      }, c.prototype.makeRBT = function (t) {
        for (var i = new Array(t), e = r.prototype._countBits(t) - 1, n = 0; n < t; n++) {
          i[n] = this.revBin(n, e, t);
        }

        return i;
      }, c.prototype.revBin = function (t, i, e) {
        if (0 === t || t === e - 1) return t;

        for (var n = 0, r = 0; r < i; r++) {
          n |= (1 & t) << i - r - 1, t >>= 1;
        }

        return n;
      }, c.prototype.permute = function (t, i, e, n, r, o) {
        for (var s = 0; s < o; s++) {
          n[s] = i[t[s]], r[s] = e[t[s]];
        }
      }, c.prototype.transform = function (t, i, e, n, r, o) {
        this.permute(o, t, i, e, n, r);

        for (var s = 1; s < r; s <<= 1) {
          for (var h = s << 1, u = Math.cos(2 * Math.PI / h), a = Math.sin(2 * Math.PI / h), l = 0; l < r; l += h) {
            for (var m = u, d = a, f = 0; f < s; f++) {
              var p = e[l + f],
                  c = n[l + f],
                  y = e[l + f + s],
                  v = n[l + f + s],
                  g = m * y - d * v;
              v = m * v + d * y, e[l + f] = p + (y = g), n[l + f] = c + v, e[l + f + s] = p - y, n[l + f + s] = c - v, f !== h && (g = u * m - a * d, d = u * d + a * m, m = g);
            }
          }
        }
      }, c.prototype.guessLen13b = function (t, i) {
        var e = 1 | Math.max(i, t),
            n = 1 & e,
            r = 0;

        for (e = e / 2 | 0; e; e >>>= 1) {
          r++;
        }

        return 1 << r + 1 + n;
      }, c.prototype.conjugate = function (t, i, e) {
        if (!(e <= 1)) for (var n = 0; n < e / 2; n++) {
          var r = t[n];
          t[n] = t[e - n - 1], t[e - n - 1] = r, r = i[n], i[n] = -i[e - n - 1], i[e - n - 1] = -r;
        }
      }, c.prototype.normalize13b = function (t, i) {
        for (var e = 0, n = 0; n < i / 2; n++) {
          var r = 8192 * Math.round(t[2 * n + 1] / i) + Math.round(t[2 * n] / i) + e;
          t[n] = 67108863 & r, e = r < 67108864 ? 0 : r / 67108864 | 0;
        }

        return t;
      }, c.prototype.convert13b = function (t, i, n, r) {
        for (var o = 0, s = 0; s < i; s++) {
          n[2 * s] = 8191 & (o += 0 | t[s]), n[2 * s + 1] = 8191 & (o >>>= 13), o >>>= 13;
        }

        for (s = 2 * i; s < r; ++s) {
          n[s] = 0;
        }

        e(0 === o), e(0 == (-8192 & o));
      }, c.prototype.stub = function (t) {
        for (var i = new Array(t), e = 0; e < t; e++) {
          i[e] = 0;
        }

        return i;
      }, c.prototype.mulp = function (t, i, e) {
        var n = 2 * this.guessLen13b(t.length, i.length),
            r = this.makeRBT(n),
            o = this.stub(n),
            s = new Array(n),
            h = new Array(n),
            u = new Array(n),
            a = new Array(n),
            l = new Array(n),
            m = new Array(n),
            d = e.words;
        d.length = n, this.convert13b(t.words, t.length, s, n), this.convert13b(i.words, i.length, a, n), this.transform(s, o, h, u, n, r), this.transform(a, o, l, m, n, r);

        for (var f = 0; f < n; f++) {
          var p = h[f] * l[f] - u[f] * m[f];
          u[f] = h[f] * m[f] + u[f] * l[f], h[f] = p;
        }

        return this.conjugate(h, u, n), this.transform(h, u, d, o, n, r), this.conjugate(d, o, n), this.normalize13b(d, n), e.negative = t.negative ^ i.negative, e.length = t.length + i.length, e.strip();
      }, r.prototype.mul = function (t) {
        var i = new r(null);
        return i.words = new Array(this.length + t.length), this.mulTo(t, i);
      }, r.prototype.mulf = function (t) {
        var i = new r(null);
        return i.words = new Array(this.length + t.length), p(this, t, i);
      }, r.prototype.imul = function (t) {
        return this.clone().mulTo(t, this);
      }, r.prototype.imuln = function (t) {
        e("number" == typeof t), e(t < 67108864);

        for (var i = 0, n = 0; n < this.length; n++) {
          var r = (0 | this.words[n]) * t,
              o = (67108863 & r) + (67108863 & i);
          i >>= 26, i += r / 67108864 | 0, i += o >>> 26, this.words[n] = 67108863 & o;
        }

        return 0 !== i && (this.words[n] = i, this.length++), this;
      }, r.prototype.muln = function (t) {
        return this.clone().imuln(t);
      }, r.prototype.sqr = function () {
        return this.mul(this);
      }, r.prototype.isqr = function () {
        return this.imul(this.clone());
      }, r.prototype.pow = function (t) {
        var i = function (t) {
          for (var i = new Array(t.bitLength()), e = 0; e < i.length; e++) {
            var n = e % 26;
            i[e] = (t.words[e / 26 | 0] & 1 << n) >>> n;
          }

          return i;
        }(t);

        if (0 === i.length) return new r(1);

        for (var e = this, n = 0; n < i.length && 0 === i[n]; n++, e = e.sqr()) {
          ;
        }

        if (++n < i.length) for (var o = e.sqr(); n < i.length; n++, o = o.sqr()) {
          0 !== i[n] && (e = e.mul(o));
        }
        return e;
      }, r.prototype.iushln = function (t) {
        e("number" == typeof t && t >= 0);
        var i,
            n = t % 26,
            r = (t - n) / 26,
            o = 67108863 >>> 26 - n << 26 - n;

        if (0 !== n) {
          var s = 0;

          for (i = 0; i < this.length; i++) {
            var h = this.words[i] & o;
            this.words[i] = (0 | this.words[i]) - h << n | s, s = h >>> 26 - n;
          }

          s && (this.words[i] = s, this.length++);
        }

        if (0 !== r) {
          for (i = this.length - 1; i >= 0; i--) {
            this.words[i + r] = this.words[i];
          }

          for (i = 0; i < r; i++) {
            this.words[i] = 0;
          }

          this.length += r;
        }

        return this.strip();
      }, r.prototype.ishln = function (t) {
        return e(0 === this.negative), this.iushln(t);
      }, r.prototype.iushrn = function (t, i, n) {
        var r;
        e("number" == typeof t && t >= 0), r = i ? (i - i % 26) / 26 : 0;
        var o = t % 26,
            s = Math.min((t - o) / 26, this.length),
            h = 67108863 ^ 67108863 >>> o << o,
            u = n;

        if (r -= s, r = Math.max(0, r), u) {
          for (var a = 0; a < s; a++) {
            u.words[a] = this.words[a];
          }

          u.length = s;
        }

        if (0 === s) ;else if (this.length > s) for (this.length -= s, a = 0; a < this.length; a++) {
          this.words[a] = this.words[a + s];
        } else this.words[0] = 0, this.length = 1;
        var l = 0;

        for (a = this.length - 1; a >= 0 && (0 !== l || a >= r); a--) {
          var m = 0 | this.words[a];
          this.words[a] = l << 26 - o | m >>> o, l = m & h;
        }

        return u && 0 !== l && (u.words[u.length++] = l), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
      }, r.prototype.ishrn = function (t, i, n) {
        return e(0 === this.negative), this.iushrn(t, i, n);
      }, r.prototype.shln = function (t) {
        return this.clone().ishln(t);
      }, r.prototype.ushln = function (t) {
        return this.clone().iushln(t);
      }, r.prototype.shrn = function (t) {
        return this.clone().ishrn(t);
      }, r.prototype.ushrn = function (t) {
        return this.clone().iushrn(t);
      }, r.prototype.testn = function (t) {
        e("number" == typeof t && t >= 0);
        var i = t % 26,
            n = (t - i) / 26;
        return !(this.length <= n || !(this.words[n] & 1 << i));
      }, r.prototype.imaskn = function (t) {
        e("number" == typeof t && t >= 0);
        var i = t % 26,
            n = (t - i) / 26;
        return e(0 === this.negative, "imaskn works only with positive numbers"), this.length <= n ? this : (0 !== i && n++, this.length = Math.min(n, this.length), 0 !== i && (this.words[this.length - 1] &= 67108863 ^ 67108863 >>> i << i), this.strip());
      }, r.prototype.maskn = function (t) {
        return this.clone().imaskn(t);
      }, r.prototype.iaddn = function (t) {
        return e("number" == typeof t), e(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
      }, r.prototype._iaddn = function (t) {
        this.words[0] += t;

        for (var i = 0; i < this.length && this.words[i] >= 67108864; i++) {
          this.words[i] -= 67108864, i === this.length - 1 ? this.words[i + 1] = 1 : this.words[i + 1]++;
        }

        return this.length = Math.max(this.length, i + 1), this;
      }, r.prototype.isubn = function (t) {
        if (e("number" == typeof t), e(t < 67108864), t < 0) return this.iaddn(-t);
        if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
        if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var i = 0; i < this.length && this.words[i] < 0; i++) {
          this.words[i] += 67108864, this.words[i + 1] -= 1;
        }
        return this.strip();
      }, r.prototype.addn = function (t) {
        return this.clone().iaddn(t);
      }, r.prototype.subn = function (t) {
        return this.clone().isubn(t);
      }, r.prototype.iabs = function () {
        return this.negative = 0, this;
      }, r.prototype.abs = function () {
        return this.clone().iabs();
      }, r.prototype._ishlnsubmul = function (t, i, n) {
        var r, o;

        this._expand(t.length + n);

        var s = 0;

        for (r = 0; r < t.length; r++) {
          o = (0 | this.words[r + n]) + s;
          var h = (0 | t.words[r]) * i;
          s = ((o -= 67108863 & h) >> 26) - (h / 67108864 | 0), this.words[r + n] = 67108863 & o;
        }

        for (; r < this.length - n; r++) {
          s = (o = (0 | this.words[r + n]) + s) >> 26, this.words[r + n] = 67108863 & o;
        }

        if (0 === s) return this.strip();

        for (e(-1 === s), s = 0, r = 0; r < this.length; r++) {
          s = (o = -(0 | this.words[r]) + s) >> 26, this.words[r] = 67108863 & o;
        }

        return this.negative = 1, this.strip();
      }, r.prototype._wordDiv = function (t, i) {
        var e,
            n = this.clone(),
            o = t,
            s = 0 | o.words[o.length - 1];
        0 != (e = 26 - this._countBits(s)) && (o = o.ushln(e), n.iushln(e), s = 0 | o.words[o.length - 1]);
        var h,
            u = n.length - o.length;

        if ("mod" !== i) {
          (h = new r(null)).length = u + 1, h.words = new Array(h.length);

          for (var a = 0; a < h.length; a++) {
            h.words[a] = 0;
          }
        }

        var l = n.clone()._ishlnsubmul(o, 1, u);

        0 === l.negative && (n = l, h && (h.words[u] = 1));

        for (var m = u - 1; m >= 0; m--) {
          var d = 67108864 * (0 | n.words[o.length + m]) + (0 | n.words[o.length + m - 1]);

          for (d = Math.min(d / s | 0, 67108863), n._ishlnsubmul(o, d, m); 0 !== n.negative;) {
            d--, n.negative = 0, n._ishlnsubmul(o, 1, m), n.isZero() || (n.negative ^= 1);
          }

          h && (h.words[m] = d);
        }

        return h && h.strip(), n.strip(), "div" !== i && 0 !== e && n.iushrn(e), {
          div: h || null,
          mod: n
        };
      }, r.prototype.divmod = function (t, i, n) {
        return e(!t.isZero()), this.isZero() ? {
          div: new r(0),
          mod: new r(0)
        } : 0 !== this.negative && 0 === t.negative ? (h = this.neg().divmod(t, i), "mod" !== i && (o = h.div.neg()), "div" !== i && (s = h.mod.neg(), n && 0 !== s.negative && s.iadd(t)), {
          div: o,
          mod: s
        }) : 0 === this.negative && 0 !== t.negative ? (h = this.divmod(t.neg(), i), "mod" !== i && (o = h.div.neg()), {
          div: o,
          mod: h.mod
        }) : 0 != (this.negative & t.negative) ? (h = this.neg().divmod(t.neg(), i), "div" !== i && (s = h.mod.neg(), n && 0 !== s.negative && s.isub(t)), {
          div: h.div,
          mod: s
        }) : t.length > this.length || this.cmp(t) < 0 ? {
          div: new r(0),
          mod: this
        } : 1 === t.length ? "div" === i ? {
          div: this.divn(t.words[0]),
          mod: null
        } : "mod" === i ? {
          div: null,
          mod: new r(this.modn(t.words[0]))
        } : {
          div: this.divn(t.words[0]),
          mod: new r(this.modn(t.words[0]))
        } : this._wordDiv(t, i);
        var o, s, h;
      }, r.prototype.div = function (t) {
        return this.divmod(t, "div", !1).div;
      }, r.prototype.mod = function (t) {
        return this.divmod(t, "mod", !1).mod;
      }, r.prototype.umod = function (t) {
        return this.divmod(t, "mod", !0).mod;
      }, r.prototype.divRound = function (t) {
        var i = this.divmod(t);
        if (i.mod.isZero()) return i.div;
        var e = 0 !== i.div.negative ? i.mod.isub(t) : i.mod,
            n = t.ushrn(1),
            r = t.andln(1),
            o = e.cmp(n);
        return o < 0 || 1 === r && 0 === o ? i.div : 0 !== i.div.negative ? i.div.isubn(1) : i.div.iaddn(1);
      }, r.prototype.modn = function (t) {
        e(t <= 67108863);

        for (var i = (1 << 26) % t, n = 0, r = this.length - 1; r >= 0; r--) {
          n = (i * n + (0 | this.words[r])) % t;
        }

        return n;
      }, r.prototype.idivn = function (t) {
        e(t <= 67108863);

        for (var i = 0, n = this.length - 1; n >= 0; n--) {
          var r = (0 | this.words[n]) + 67108864 * i;
          this.words[n] = r / t | 0, i = r % t;
        }

        return this.strip();
      }, r.prototype.divn = function (t) {
        return this.clone().idivn(t);
      }, r.prototype.egcd = function (t) {
        e(0 === t.negative), e(!t.isZero());
        var i = this,
            n = t.clone();
        i = 0 !== i.negative ? i.umod(t) : i.clone();

        for (var o = new r(1), s = new r(0), h = new r(0), u = new r(1), a = 0; i.isEven() && n.isEven();) {
          i.iushrn(1), n.iushrn(1), ++a;
        }

        for (var l = n.clone(), m = i.clone(); !i.isZero();) {
          for (var d = 0, f = 1; 0 == (i.words[0] & f) && d < 26; ++d, f <<= 1) {
            ;
          }

          if (d > 0) for (i.iushrn(d); d-- > 0;) {
            (o.isOdd() || s.isOdd()) && (o.iadd(l), s.isub(m)), o.iushrn(1), s.iushrn(1);
          }

          for (var p = 0, c = 1; 0 == (n.words[0] & c) && p < 26; ++p, c <<= 1) {
            ;
          }

          if (p > 0) for (n.iushrn(p); p-- > 0;) {
            (h.isOdd() || u.isOdd()) && (h.iadd(l), u.isub(m)), h.iushrn(1), u.iushrn(1);
          }
          i.cmp(n) >= 0 ? (i.isub(n), o.isub(h), s.isub(u)) : (n.isub(i), h.isub(o), u.isub(s));
        }

        return {
          a: h,
          b: u,
          gcd: n.iushln(a)
        };
      }, r.prototype._invmp = function (t) {
        e(0 === t.negative), e(!t.isZero());
        var i = this,
            n = t.clone();
        i = 0 !== i.negative ? i.umod(t) : i.clone();

        for (var o, s = new r(1), h = new r(0), u = n.clone(); i.cmpn(1) > 0 && n.cmpn(1) > 0;) {
          for (var a = 0, l = 1; 0 == (i.words[0] & l) && a < 26; ++a, l <<= 1) {
            ;
          }

          if (a > 0) for (i.iushrn(a); a-- > 0;) {
            s.isOdd() && s.iadd(u), s.iushrn(1);
          }

          for (var m = 0, d = 1; 0 == (n.words[0] & d) && m < 26; ++m, d <<= 1) {
            ;
          }

          if (m > 0) for (n.iushrn(m); m-- > 0;) {
            h.isOdd() && h.iadd(u), h.iushrn(1);
          }
          i.cmp(n) >= 0 ? (i.isub(n), s.isub(h)) : (n.isub(i), h.isub(s));
        }

        return (o = 0 === i.cmpn(1) ? s : h).cmpn(0) < 0 && o.iadd(t), o;
      }, r.prototype.gcd = function (t) {
        if (this.isZero()) return t.abs();
        if (t.isZero()) return this.abs();
        var i = this.clone(),
            e = t.clone();
        i.negative = 0, e.negative = 0;

        for (var n = 0; i.isEven() && e.isEven(); n++) {
          i.iushrn(1), e.iushrn(1);
        }

        for (;;) {
          for (; i.isEven();) {
            i.iushrn(1);
          }

          for (; e.isEven();) {
            e.iushrn(1);
          }

          var r = i.cmp(e);

          if (r < 0) {
            var o = i;
            i = e, e = o;
          } else if (0 === r || 0 === e.cmpn(1)) break;

          i.isub(e);
        }

        return e.iushln(n);
      }, r.prototype.invm = function (t) {
        return this.egcd(t).a.umod(t);
      }, r.prototype.isEven = function () {
        return 0 == (1 & this.words[0]);
      }, r.prototype.isOdd = function () {
        return 1 == (1 & this.words[0]);
      }, r.prototype.andln = function (t) {
        return this.words[0] & t;
      }, r.prototype.bincn = function (t) {
        e("number" == typeof t);
        var i = t % 26,
            n = (t - i) / 26,
            r = 1 << i;
        if (this.length <= n) return this._expand(n + 1), this.words[n] |= r, this;

        for (var o = r, s = n; 0 !== o && s < this.length; s++) {
          var h = 0 | this.words[s];
          o = (h += o) >>> 26, this.words[s] = h &= 67108863;
        }

        return 0 !== o && (this.words[s] = o, this.length++), this;
      }, r.prototype.isZero = function () {
        return 1 === this.length && 0 === this.words[0];
      }, r.prototype.cmpn = function (t) {
        var i,
            n = t < 0;
        if (0 !== this.negative && !n) return -1;
        if (0 === this.negative && n) return 1;
        if (this.strip(), this.length > 1) i = 1;else {
          n && (t = -t), e(t <= 67108863, "Number is too big");
          var r = 0 | this.words[0];
          i = r === t ? 0 : r < t ? -1 : 1;
        }
        return 0 !== this.negative ? 0 | -i : i;
      }, r.prototype.cmp = function (t) {
        if (0 !== this.negative && 0 === t.negative) return -1;
        if (0 === this.negative && 0 !== t.negative) return 1;
        var i = this.ucmp(t);
        return 0 !== this.negative ? 0 | -i : i;
      }, r.prototype.ucmp = function (t) {
        if (this.length > t.length) return 1;
        if (this.length < t.length) return -1;

        for (var i = 0, e = this.length - 1; e >= 0; e--) {
          var n = 0 | this.words[e],
              r = 0 | t.words[e];

          if (n !== r) {
            n < r ? i = -1 : n > r && (i = 1);
            break;
          }
        }

        return i;
      }, r.prototype.gtn = function (t) {
        return 1 === this.cmpn(t);
      }, r.prototype.gt = function (t) {
        return 1 === this.cmp(t);
      }, r.prototype.gten = function (t) {
        return this.cmpn(t) >= 0;
      }, r.prototype.gte = function (t) {
        return this.cmp(t) >= 0;
      }, r.prototype.ltn = function (t) {
        return -1 === this.cmpn(t);
      }, r.prototype.lt = function (t) {
        return -1 === this.cmp(t);
      }, r.prototype.lten = function (t) {
        return this.cmpn(t) <= 0;
      }, r.prototype.lte = function (t) {
        return this.cmp(t) <= 0;
      }, r.prototype.eqn = function (t) {
        return 0 === this.cmpn(t);
      }, r.prototype.eq = function (t) {
        return 0 === this.cmp(t);
      }, r.red = function (t) {
        return new _(t);
      }, r.prototype.toRed = function (t) {
        return e(!this.red, "Already a number in reduction context"), e(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
      }, r.prototype.fromRed = function () {
        return e(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, r.prototype._forceRed = function (t) {
        return this.red = t, this;
      }, r.prototype.forceRed = function (t) {
        return e(!this.red, "Already a number in reduction context"), this._forceRed(t);
      }, r.prototype.redAdd = function (t) {
        return e(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
      }, r.prototype.redIAdd = function (t) {
        return e(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
      }, r.prototype.redSub = function (t) {
        return e(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
      }, r.prototype.redISub = function (t) {
        return e(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
      }, r.prototype.redShl = function (t) {
        return e(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
      }, r.prototype.redMul = function (t) {
        return e(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
      }, r.prototype.redIMul = function (t) {
        return e(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
      }, r.prototype.redSqr = function () {
        return e(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, r.prototype.redISqr = function () {
        return e(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, r.prototype.redSqrt = function () {
        return e(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, r.prototype.redInvm = function () {
        return e(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, r.prototype.redNeg = function () {
        return e(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, r.prototype.redPow = function (t) {
        return e(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
      };
      var y = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };

      function v(t, i) {
        this.name = t, this.p = new r(i, 16), this.n = this.p.bitLength(), this.k = new r(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }

      function g() {
        v.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
      }

      function M() {
        v.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
      }

      function w() {
        v.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
      }

      function b() {
        v.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
      }

      function _(t) {
        if ("string" == typeof t) {
          var i = r._prime(t);

          this.m = i.p, this.prime = i;
        } else e(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
      }

      function k(t) {
        _.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new r(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }

      v.prototype._tmp = function () {
        var t = new r(null);
        return t.words = new Array(Math.ceil(this.n / 13)), t;
      }, v.prototype.ireduce = function (t) {
        var i,
            e = t;

        do {
          this.split(e, this.tmp), i = (e = (e = this.imulK(e)).iadd(this.tmp)).bitLength();
        } while (i > this.n);

        var n = i < this.n ? -1 : e.ucmp(this.p);
        return 0 === n ? (e.words[0] = 0, e.length = 1) : n > 0 ? e.isub(this.p) : void 0 !== e.strip ? e.strip() : e._strip(), e;
      }, v.prototype.split = function (t, i) {
        t.iushrn(this.n, 0, i);
      }, v.prototype.imulK = function (t) {
        return t.imul(this.k);
      }, n(g, v), g.prototype.split = function (t, i) {
        for (var e = Math.min(t.length, 9), n = 0; n < e; n++) {
          i.words[n] = t.words[n];
        }

        if (i.length = e, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
        var r = t.words[9];

        for (i.words[i.length++] = 4194303 & r, n = 10; n < t.length; n++) {
          var o = 0 | t.words[n];
          t.words[n - 10] = (4194303 & o) << 4 | r >>> 22, r = o;
        }

        t.words[n - 10] = r >>>= 22, t.length -= 0 === r && t.length > 10 ? 10 : 9;
      }, g.prototype.imulK = function (t) {
        t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

        for (var i = 0, e = 0; e < t.length; e++) {
          var n = 0 | t.words[e];
          t.words[e] = 67108863 & (i += 977 * n), i = 64 * n + (i / 67108864 | 0);
        }

        return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
      }, n(M, v), n(w, v), n(b, v), b.prototype.imulK = function (t) {
        for (var i = 0, e = 0; e < t.length; e++) {
          var n = 19 * (0 | t.words[e]) + i,
              r = 67108863 & n;
          n >>>= 26, t.words[e] = r, i = n;
        }

        return 0 !== i && (t.words[t.length++] = i), t;
      }, r._prime = function (t) {
        if (y[t]) return y[t];
        var i;
        if ("k256" === t) i = new g();else if ("p224" === t) i = new M();else if ("p192" === t) i = new w();else {
          if ("p25519" !== t) throw new Error("Unknown prime " + t);
          i = new b();
        }
        return y[t] = i, i;
      }, _.prototype._verify1 = function (t) {
        e(0 === t.negative, "red works only with positives"), e(t.red, "red works only with red numbers");
      }, _.prototype._verify2 = function (t, i) {
        e(0 == (t.negative | i.negative), "red works only with positives"), e(t.red && t.red === i.red, "red works only with red numbers");
      }, _.prototype.imod = function (t) {
        return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
      }, _.prototype.neg = function (t) {
        return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
      }, _.prototype.add = function (t, i) {
        this._verify2(t, i);

        var e = t.add(i);
        return e.cmp(this.m) >= 0 && e.isub(this.m), e._forceRed(this);
      }, _.prototype.iadd = function (t, i) {
        this._verify2(t, i);

        var e = t.iadd(i);
        return e.cmp(this.m) >= 0 && e.isub(this.m), e;
      }, _.prototype.sub = function (t, i) {
        this._verify2(t, i);

        var e = t.sub(i);
        return e.cmpn(0) < 0 && e.iadd(this.m), e._forceRed(this);
      }, _.prototype.isub = function (t, i) {
        this._verify2(t, i);

        var e = t.isub(i);
        return e.cmpn(0) < 0 && e.iadd(this.m), e;
      }, _.prototype.shl = function (t, i) {
        return this._verify1(t), this.imod(t.ushln(i));
      }, _.prototype.imul = function (t, i) {
        return this._verify2(t, i), this.imod(t.imul(i));
      }, _.prototype.mul = function (t, i) {
        return this._verify2(t, i), this.imod(t.mul(i));
      }, _.prototype.isqr = function (t) {
        return this.imul(t, t.clone());
      }, _.prototype.sqr = function (t) {
        return this.mul(t, t);
      }, _.prototype.sqrt = function (t) {
        if (t.isZero()) return t.clone();
        var i = this.m.andln(3);

        if (e(i % 2 == 1), 3 === i) {
          var n = this.m.add(new r(1)).iushrn(2);
          return this.pow(t, n);
        }

        for (var o = this.m.subn(1), s = 0; !o.isZero() && 0 === o.andln(1);) {
          s++, o.iushrn(1);
        }

        e(!o.isZero());
        var h = new r(1).toRed(this),
            u = h.redNeg(),
            a = this.m.subn(1).iushrn(1),
            l = this.m.bitLength();

        for (l = new r(2 * l * l).toRed(this); 0 !== this.pow(l, a).cmp(u);) {
          l.redIAdd(u);
        }

        for (var m = this.pow(l, o), d = this.pow(t, o.addn(1).iushrn(1)), f = this.pow(t, o), p = s; 0 !== f.cmp(h);) {
          for (var c = f, y = 0; 0 !== c.cmp(h); y++) {
            c = c.redSqr();
          }

          e(y < p);
          var v = this.pow(m, new r(1).iushln(p - y - 1));
          d = d.redMul(v), m = v.redSqr(), f = f.redMul(m), p = y;
        }

        return d;
      }, _.prototype.invm = function (t) {
        var i = t._invmp(this.m);

        return 0 !== i.negative ? (i.negative = 0, this.imod(i).redNeg()) : this.imod(i);
      }, _.prototype.pow = function (t, i) {
        if (i.isZero()) return new r(1).toRed(this);
        if (0 === i.cmpn(1)) return t.clone();
        var e = new Array(16);
        e[0] = new r(1).toRed(this), e[1] = t;

        for (var n = 2; n < e.length; n++) {
          e[n] = this.mul(e[n - 1], t);
        }

        var o = e[0],
            s = 0,
            h = 0,
            u = i.bitLength() % 26;

        for (0 === u && (u = 26), n = i.length - 1; n >= 0; n--) {
          for (var a = i.words[n], l = u - 1; l >= 0; l--) {
            var m = a >> l & 1;
            o !== e[0] && (o = this.sqr(o)), 0 !== m || 0 !== s ? (s <<= 1, s |= m, (4 == ++h || 0 === n && 0 === l) && (o = this.mul(o, e[s]), h = 0, s = 0)) : h = 0;
          }

          u = 26;
        }

        return o;
      }, _.prototype.convertTo = function (t) {
        var i = t.umod(this.m);
        return i === t ? i.clone() : i;
      }, _.prototype.convertFrom = function (t) {
        var i = t.clone();
        return i.red = null, i;
      }, r.mont = function (t) {
        return new k(t);
      }, n(k, _), k.prototype.convertTo = function (t) {
        return this.imod(t.ushln(this.shift));
      }, k.prototype.convertFrom = function (t) {
        var i = this.imod(t.mul(this.rinv));
        return i.red = null, i;
      }, k.prototype.imul = function (t, i) {
        if (t.isZero() || i.isZero()) return t.words[0] = 0, t.length = 1, t;
        var e = t.imul(i),
            n = e.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
            r = e.isub(n).iushrn(this.shift),
            o = r;
        return r.cmp(this.m) >= 0 ? o = r.isub(this.m) : r.cmpn(0) < 0 && (o = r.iadd(this.m)), o._forceRed(this);
      }, k.prototype.mul = function (t, i) {
        if (t.isZero() || i.isZero()) return new r(0)._forceRed(this);
        var e = t.mul(i),
            n = e.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
            o = e.isub(n).iushrn(this.shift),
            s = o;
        return o.cmp(this.m) >= 0 ? s = o.isub(this.m) : o.cmpn(0) < 0 && (s = o.iadd(this.m)), s._forceRed(this);
      }, k.prototype.invm = function (t) {
        return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
      };
    }(t, a);
  }(e = {
    path: void 0,
    exports: {},
    require: function require(t, i) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }();
    }
  }), e.exports;
}(),
    m = [{
  constant: !0,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "owners",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: !1,
  stateMutability: "view",
  type: "function"
}, {
  constant: !0,
  inputs: [{
    name: "",
    type: "address"
  }, {
    name: "",
    type: "bytes32"
  }, {
    name: "",
    type: "address"
  }],
  name: "delegates",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: !1,
  stateMutability: "view",
  type: "function"
}, {
  constant: !0,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "nonce",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: !1,
  stateMutability: "view",
  type: "function"
}, {
  constant: !0,
  inputs: [{
    name: "",
    type: "address"
  }],
  name: "changed",
  outputs: [{
    name: "",
    type: "uint256"
  }],
  payable: !1,
  stateMutability: "view",
  type: "function"
}, {
  anonymous: !1,
  inputs: [{
    indexed: !0,
    name: "identity",
    type: "address"
  }, {
    indexed: !1,
    name: "owner",
    type: "address"
  }, {
    indexed: !1,
    name: "previousChange",
    type: "uint256"
  }],
  name: "DIDOwnerChanged",
  type: "event"
}, {
  anonymous: !1,
  inputs: [{
    indexed: !0,
    name: "identity",
    type: "address"
  }, {
    indexed: !1,
    name: "delegateType",
    type: "bytes32"
  }, {
    indexed: !1,
    name: "delegate",
    type: "address"
  }, {
    indexed: !1,
    name: "validTo",
    type: "uint256"
  }, {
    indexed: !1,
    name: "previousChange",
    type: "uint256"
  }],
  name: "DIDDelegateChanged",
  type: "event"
}, {
  anonymous: !1,
  inputs: [{
    indexed: !0,
    name: "identity",
    type: "address"
  }, {
    indexed: !1,
    name: "name",
    type: "bytes32"
  }, {
    indexed: !1,
    name: "value",
    type: "bytes"
  }, {
    indexed: !1,
    name: "validTo",
    type: "uint256"
  }, {
    indexed: !1,
    name: "previousChange",
    type: "uint256"
  }],
  name: "DIDAttributeChanged",
  type: "event"
}, {
  constant: !0,
  inputs: [{
    name: "identity",
    type: "address"
  }],
  name: "identityOwner",
  outputs: [{
    name: "",
    type: "address"
  }],
  payable: !1,
  stateMutability: "view",
  type: "function"
}, {
  constant: !0,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "delegateType",
    type: "bytes32"
  }, {
    name: "delegate",
    type: "address"
  }],
  name: "validDelegate",
  outputs: [{
    name: "",
    type: "bool"
  }],
  payable: !1,
  stateMutability: "view",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "newOwner",
    type: "address"
  }],
  name: "changeOwner",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "sigV",
    type: "uint8"
  }, {
    name: "sigR",
    type: "bytes32"
  }, {
    name: "sigS",
    type: "bytes32"
  }, {
    name: "newOwner",
    type: "address"
  }],
  name: "changeOwnerSigned",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "delegateType",
    type: "bytes32"
  }, {
    name: "delegate",
    type: "address"
  }, {
    name: "validity",
    type: "uint256"
  }],
  name: "addDelegate",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "sigV",
    type: "uint8"
  }, {
    name: "sigR",
    type: "bytes32"
  }, {
    name: "sigS",
    type: "bytes32"
  }, {
    name: "delegateType",
    type: "bytes32"
  }, {
    name: "delegate",
    type: "address"
  }, {
    name: "validity",
    type: "uint256"
  }],
  name: "addDelegateSigned",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "delegateType",
    type: "bytes32"
  }, {
    name: "delegate",
    type: "address"
  }],
  name: "revokeDelegate",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "sigV",
    type: "uint8"
  }, {
    name: "sigR",
    type: "bytes32"
  }, {
    name: "sigS",
    type: "bytes32"
  }, {
    name: "delegateType",
    type: "bytes32"
  }, {
    name: "delegate",
    type: "address"
  }],
  name: "revokeDelegateSigned",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "name",
    type: "bytes32"
  }, {
    name: "value",
    type: "bytes"
  }, {
    name: "validity",
    type: "uint256"
  }],
  name: "setAttribute",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "sigV",
    type: "uint8"
  }, {
    name: "sigR",
    type: "bytes32"
  }, {
    name: "sigS",
    type: "bytes32"
  }, {
    name: "name",
    type: "bytes32"
  }, {
    name: "value",
    type: "bytes"
  }, {
    name: "validity",
    type: "uint256"
  }],
  name: "setAttributeSigned",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "name",
    type: "bytes32"
  }, {
    name: "value",
    type: "bytes"
  }],
  name: "revokeAttribute",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}, {
  constant: !1,
  inputs: [{
    name: "identity",
    type: "address"
  }, {
    name: "sigV",
    type: "uint8"
  }, {
    name: "sigR",
    type: "bytes32"
  }, {
    name: "sigS",
    type: "bytes32"
  }, {
    name: "name",
    type: "bytes32"
  }, {
    name: "value",
    type: "bytes"
  }],
  name: "revokeAttributeSigned",
  outputs: [],
  payable: !1,
  stateMutability: "nonpayable",
  type: "function"
}];

function d(t) {
  return r.Buffer.from(u.keccak_256.arrayBuffer(t));
}

var f = new h.ec("secp256k1");

function p(t) {
  var i = ("" + t).startsWith("0x") ? t.slice(2) : t,
      e = f.keyFromPublic(i, "hex").getPublic().encode("hex");
  return function (t) {
    var i = t;
    var e = d(i = i.substring(2).toLowerCase());
    i = i.split("");

    for (var n = 0; n < 40; n += 2) {
      e[n / 2] >> 4 >= 8 && (i[n] = i[n].toUpperCase()), (15 & e[n / 2]) >= 8 && (i[n + 1] = i[n + 1].toUpperCase());
    }

    return "0x" + i.join("");
  }("0x" + d(r.Buffer.from(e.slice(2), "hex")).slice(-20).toString("hex"));
}

function c(t, i, e) {
  if (!t.s) {
    if (e instanceof v) {
      if (!e.s) return void (e.o = c.bind(null, t, i));
      1 & i && (i = e.s), e = e.v;
    }

    if (e && e.then) return void e.then(c.bind(null, t, i), c.bind(null, t, 2));
    t.s = i, t.v = e;
    var _n = t.o;
    _n && _n(t);
  }
}

var y = "0xdca7ef03e98e0dc2b855be647c39abe984fcf21b",
    v = function () {
  function t() {}

  return t.prototype.then = function (i, e) {
    var n = new t(),
        r = this.s;

    if (r) {
      var _t2 = 1 & r ? i : e;

      if (_t2) {
        try {
          c(n, 1, _t2(this.v));
        } catch (t) {
          c(n, 2, t);
        }

        return n;
      }

      return this;
    }

    return this.o = function (t) {
      try {
        var _r = t.v;
        1 & t.s ? c(n, 1, i ? i(_r) : _r) : e ? c(n, 1, e(_r)) : c(n, 2, _r);
      } catch (t) {
        c(n, 2, t);
      }
    }, n;
  }, t;
}();

function g(t) {
  return t instanceof v && 1 & t.s;
}

var M = /^(.*)?(0x[0-9a-fA-F]{40}|0x[0-9a-fA-F]{66})$/;

function w(t) {
  return r.Buffer.from(t.slice(2), "hex").toString("utf8").replace(/\0+$/, "");
}

function b(t) {
  var i = "0x" + r.Buffer.from(t).slice(0, 32).toString("hex");
  return i + "0".repeat(66 - i.length);
}

var _ = {
  Secp256k1SignatureAuthentication2018: b("sigAuth"),
  Secp256k1VerificationKey2018: b("veriKey")
},
    k = {
  sigAuth: "SignatureAuthentication2018",
  veriKey: "VerificationKey2018",
  enc: "KeyAgreementKey2019"
};

function x(t, i, e, n) {
  var o = new l(Math.floor(new Date().getTime() / 1e3)),
      s = [{
    id: t + "#controller",
    type: "Secp256k1VerificationKey2018",
    controller: t,
    ethereumAddress: i
  }],
      h = [{
    type: "Secp256k1SignatureAuthentication2018",
    publicKey: t + "#controller"
  }];
  e && (s.push({
    id: t + "#controllerKey",
    type: "Secp256k1VerificationKey2018",
    controller: t,
    publicKeyHex: e
  }), h.push({
    type: "Secp256k1SignatureAuthentication2018",
    publicKey: t + "#controllerKey"
  }));
  var u = 0;
  var a = {},
      m = {},
      d = {};

  var _iterator = _createForOfIteratorHelper(n),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _i = _step.value;

      var _e = _i.validTo,
          _n2 = "".concat(_i._eventName, "-").concat(_i.delegateType || _i.name, "-").concat(_i.delegate || _i.value);

      if (_e && _e.gte(o)) {
        if ("DIDDelegateChanged" === _i._eventName) switch (u++, w(_i.delegateType)) {
          case "sigAuth":
            a[_n2] = {
              type: "Secp256k1SignatureAuthentication2018",
              publicKey: "".concat(t, "#delegate-").concat(u)
            };

          case "veriKey":
            m[_n2] = {
              id: "".concat(t, "#delegate-").concat(u),
              type: "Secp256k1VerificationKey2018",
              controller: t,
              ethereumAddress: _i.delegate
            };
        } else if ("DIDAttributeChanged" === _i._eventName) {
          var _e2 = w(_i.name).match(/^did\/(pub|auth|svc)\/(\w+)(\/(\w+))?(\/(\w+))?$/);

          if (_e2) {
            var _o = _e2[2],
                _s = k[_e2[4]] || _e2[4],
                _h = _e2[6];

            switch (_e2[1]) {
              case "pub":
                {
                  u++;
                  var _e3 = {
                    id: "".concat(t, "#delegate-").concat(u),
                    type: "".concat(_o).concat(_s),
                    controller: t
                  };

                  switch (_h) {
                    case null:
                    case void 0:
                    case "hex":
                      _e3.publicKeyHex = _i.value.slice(2);
                      break;

                    case "base64":
                      _e3.publicKeyBase64 = r.Buffer.from(_i.value.slice(2), "hex").toString("base64");
                      break;

                    case "base58":
                      _e3.publicKeyBase58 = r.Buffer.from(_i.value.slice(2), "hex").toString("base58");
                      break;

                    case "pem":
                      _e3.publicKeyPem = r.Buffer.from(_i.value.slice(2), "hex").toString();
                      break;

                    default:
                      _e3.value = _i.value;
                  }

                  m[_n2] = _e3;
                  break;
                }

              case "svc":
                d[_n2] = {
                  type: _o,
                  serviceEndpoint: r.Buffer.from(_i.value.slice(2), "hex").toString()
                };
            }
          }
        }
      } else u > 0 && ("DIDDelegateChanged" === _i._eventName || "DIDAttributeChanged" === _i._eventName && w(_i.name).match(/^did\/pub\//)) && _e.lt(o) && u--, delete a[_n2], delete m[_n2], delete d[_n2];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var f = {
    "@context": "https://w3id.org/did/v1",
    id: t,
    publicKey: s.concat(Object.values(m)),
    authentication: h.concat(Object.values(a))
  };
  return Object.values(d).length > 0 && (f.service = Object.values(d)), f;
}

function S() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var n = function () {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return t.provider ? t.provider : t.web3 ? t.web3.currentProvider : t.rpcUrl ? new i(t.rpcUrl) : null;
  }(t);

  if (null === n) return null;
  var r = new e(n),
      o = t.registry || y;
  return {
    eth: r,
    registryAddress: o,
    didReg: new s(r)(m).at(o)
  };
}

function A() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var i = {};

  for (var _e4 = 0; _e4 < t.length; _e4++) {
    var _n3 = t[_e4];
    i[_n3.name] = S(_n3), null === i[_n3.name] && console.warn("invalid configuration for " + _n3.name);
  }

  return i;
}

module.exports = {
  REGISTRY: y,
  bytes32toString: w,
  stringToBytes32: b,
  delegateTypes: _,
  attrTypes: k,
  wrapDidDocument: x,
  getResolver: function getResolver() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var i = n.logDecoder(m, !1),
        e = _objectSpread({
      mainnet: S(t)
    }, A(t.networks));

    return function () {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if ((i.provider || i.web3 || i.rpcUrl) && !t.mainnet) throw new Error("Ethereum provider configuration for mainnet was attempted but no valid configuration was provided.");

      if (i && i.networks) {
        var _iterator2 = _createForOfIteratorHelper(i.networks),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e5 = _step2.value;
            if (!t[_e5.name]) throw new Error("Ethereum provider configuration for ".concat(_e5.name, " was attempted but no valid configuration was provided"));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      var e = 0;

      for (var _i2 = 0, _Object$keys = Object.keys(t); _i2 < _Object$keys.length; _i2++) {
        var _i3 = _Object$keys[_i2];
        null !== t[_i3] && e++;
      }

      if (0 === e) throw new Error("EthrDIDResolver requires a provider configuration for at least one network");
    }(e, t), {
      ethr: function ethr(t, n) {
        try {
          var _r2 = n.id.match(M);

          if (!_r2) throw new Error("Not a valid ethr DID: " + t);

          var _o2 = _r2[2],
              _s2 = _r2[1] ? _r2[1].slice(0, -1) : "mainnet";

          if (!e[_s2]) throw new Error("No conf for networkId: " + _s2);
          return Promise.resolve(function (t, n) {
            try {
              var _o3 = [];

              var _ref = (r = t).length > 42 ? {
                address: p(r),
                publicKey: r
              } : {
                address: r
              },
                  _s3 = _ref.address,
                  _h2 = _ref.publicKey,
                  _u = _s3;

              return Promise.resolve(function (t, i) {
                try {
                  return Promise.resolve(e[i].didReg.changed(t)).then(function (t) {
                    if (t) return t[0];
                  });
                } catch (t) {
                  return Promise.reject(t);
                }
              }(_s3, n)).then(function (t) {
                function r() {
                  function r() {
                    return {
                      controller: _u,
                      history: _o3,
                      publicKey: _h2
                    };
                  }

                  var a = function (t, i, e) {
                    for (var n;;) {
                      var r = t();
                      if (g(r) && (r = r.v), !r) return o;

                      if (r.then) {
                        n = 0;
                        break;
                      }

                      var o = e();

                      if (o && o.then) {
                        if (!g(o)) {
                          n = 1;
                          break;
                        }

                        o = o.s;
                      }
                    }

                    var s = new v(),
                        h = c.bind(null, s, 2);
                    return (0 === n ? r.then(a) : 1 === n ? o.then(u) : (void 0).then(function () {
                      (r = t()) ? r.then ? r.then(a).then(void 0, h) : a(r) : c(s, 1, o);
                    })).then(void 0, h), s;

                    function u(i) {
                      o = i;

                      do {
                        if (!(r = t()) || g(r) && !r.v) return void c(s, 1, o);
                        if (r.then) return void r.then(a).then(void 0, h);
                        g(o = e()) && (o = o.v);
                      } while (!o || !o.then);

                      o.then(u).then(void 0, h);
                    }

                    function a(t) {
                      t ? (o = e()) && o.then ? o.then(u).then(void 0, h) : u(o) : c(s, 1, o);
                    }
                  }(function () {
                    return !!t;
                  }, 0, function () {
                    var r = t;
                    return Promise.resolve(e[n].eth.getLogs({
                      address: e[n].registryAddress,
                      topics: [null, "0x000000000000000000000000" + _s3.slice(2)],
                      fromBlock: t,
                      toBlock: t
                    })).then(function (e) {
                      var n = i(e);
                      n.reverse(), t = void 0;

                      var _iterator3 = _createForOfIteratorHelper(n),
                          _step3;

                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          var _i4 = _step3.value;
                          _o3.unshift(_i4), _i4.previousChange.lt(r) && (t = _i4.previousChange);
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }
                    });
                  });

                  return a && a.then ? a.then(r) : r();
                }

                var a = function () {
                  if (t) return Promise.resolve(e[n].didReg.identityOwner(_s3)).then(function (t) {
                    var i = "" + t[0];
                    i.toLowerCase() !== _u.toLowerCase() && (_h2 = null), _u = i;
                  });
                }();

                return a && a.then ? a.then(r) : r();
              });
            } catch (t) {
              return Promise.reject(t);
            }

            var r;
          }(_o2, _s2)).then(function (_ref2) {
            var i = _ref2.controller,
                e = _ref2.history,
                n = _ref2.publicKey;
            return x(t, i, n, e);
          });
        } catch (t) {
          return Promise.reject(t);
        }
      }
    };
  },
  identifierMatcher: M
};